import React from 'react'
import { AlignItems, Box, Color, Display, Icon, Text } from '@gousto-internal/citrus-react'

type DietaryWarningTagVariant = 'default' | 'stacked'

type DietaryWarningTagProps = {
  text: string
  variant?: DietaryWarningTagVariant
}

const radiusStylesByVariant: Record<
  DietaryWarningTagVariant,
  { tag: React.CSSProperties; icon: React.CSSProperties }
> = {
  default: {
    tag: {
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
    icon: {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
  },
  stacked: {
    tag: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: 0,
      borderTopRightRadius: '4px',
    },
    icon: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
}

export function DietaryWarningTag({ text, variant = 'default' }: DietaryWarningTagProps) {
  return (
    <Box
      data-testid="dietary-warning-tag"
      bg={Color.ColdGrey_900}
      height="24px"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={1}
      maxWidth="100%"
      minWidth="0"
      style={radiusStylesByVariant[variant].tag}
      width="fit-content"
    >
      <Box
        data-testid="info-icon"
        style={{
          ...radiusStylesByVariant[variant].icon,
          flexShrink: 0,
        }}
        bg={Color.Warning_700}
        width="22px"
        paddingH={0.75}
        paddingV={1}
        display={Display.Flex}
      >
        <Icon name="info" style={{ color: Color.White }} size={4} />
      </Box>
      <Box data-testid="dietary-warning-text" minWidth="0" paddingRight={2}>
        <Text
          size={2}
          color={Color.White}
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {text}
        </Text>
      </Box>
    </Box>
  )
}
